import * as React from 'react';

export const MetaPixel = () => {
  return (
    <>
      <script
        type={"text/javascript"}
        dangerouslySetInnerHTML={{
          __html:
          '!function(f,b,e,v,n,t,s)\n' +
            '  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?\n' +
            '  n.callMethod.apply(n,arguments):n.queue.push(arguments)};\n' +
            '  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version="2.0";\n' +
            '  n.queue=[];t=b.createElement(e);t.async=!0;\n' +
            '  t.src=v;s=b.getElementsByTagName(e)[0];\n' +
            '  s.parentNode.insertBefore(t,s)}(window, document,"script",\n' +
            '  "https://connect.facebook.net/en_US/fbevents.js");\n' +
            '  fbq("init", "1977649452578746");\n' +
            '  fbq("track", "PageView");'
        }}
      ></script>
      <noscript>
        <img
          src="https://www.facebook.com/tr?id=1977649452578746&ev=PageView&noscript=1"
          width={"1"}
          height={"1"}
          style={{ display: "none" }}
          alt={""}
        />
      </noscript>
    </>
  );
};
